import React from 'react';
import SalesTab from './SalesTab';
import ProductsTab from './ProductsTab';
import TeamTab from './TeamTab';
import CustomersTab from './CustomersTab';
import FinanceTab from './FinanceTab';
import SettingsTab from './SettingsTab';

/**
 * Higher-order component that wraps a page with its tab navigation.
 * The tab bar renders above the page content.
 */
const withPageTab = (TabComponent, PageComponent) => {
  const Wrapped = (props) => (
    <TabComponent darkMode={props.darkMode}>
      <PageComponent {...props} />
    </TabComponent>
  );
  Wrapped.displayName = `${TabComponent.name || 'Tab'}(${PageComponent.displayName || PageComponent.name || 'Page'})`;
  return Wrapped;
};

export { withPageTab, SalesTab, ProductsTab, TeamTab, CustomersTab, FinanceTab, SettingsTab };
